import { v3 } from '@adobe/edex/frontend/api/v3';
import { AxiosRequestConfig } from 'axios';

export const EXPORT_TIMEOUT = +process.env.NX_EXPORT_TIMEOUT || 5 * 60 * 1000;
export const IMPORT_TIMEOUT = +process.env.NX_IMPORT_TIMEOUT || 5 * 60 * 1000;
export const UPDATE_ENROLLMENTS_TIMEOUT = +process.env.NX_UPDATE_ENROLLMENTS_TIMEOUT || 5 * 60 * 10000;

const baseURL = `/courses`;

export function listUpcoming() {
  return v3.get(`${baseURL}/upcoming`);
}

export function paginate(params?) {
  return v3.get(`${baseURL}`, { params });
}

export function listInProgress() {
  return v3.get(`${baseURL}/progress`);
}

export function listEnrolledIn(config: AxiosRequestConfig) {
  return v3.get(`${baseURL}/learning`, config);
}

export function fetchCourse(id) {
  return v3.get(`${baseURL}/${id}`);
}

export function completeStep(courseID, workshopID, workshopStepID) {
  return v3.put(`${baseURL}/${courseID}/${workshopID}/${workshopStepID}`);
}

export function enroll(id) {
  return v3.post(`${baseURL}/${id}/enroll`);
}

export function unenroll(id) {
  return v3.post(`${baseURL}/${id}/unenroll`);
}

export function educators(id) {
  return v3.get(`${baseURL}/${id}/educators`);
}

export function fetchEmailTemplates(id) {
  return v3.get(`${baseURL}/${id}/email-templates`);
}

export function listEnrollees(courseID, config: AxiosRequestConfig) {
  return v3.get(`${baseURL}/${courseID}/enrollees`, config);
}

export function fetchEnrolleeProgress(courseID, memberID) {
  return v3.get(`${baseURL}/${courseID}/enrollees/${memberID}`);
}

export function updateEnrollee(courseID, params) {
  return v3.put(`${baseURL}/${courseID}/enrollees`, params);
}

export function createEnrollee(courseID, params) {
  return v3.post(`${baseURL}/${courseID}/enrollees`, params);
}

export function exportEnrolleesCSV(courseID) {
  return v3.post(`${baseURL}/${courseID}/export`, null, {
    timeout: EXPORT_TIMEOUT,
  });
}

export function importEnrolleesCSV(formData, courseID) {
  return v3.post(`${baseURL}/enrollments/file/import?courseID=${courseID}`, formData, {
    timeout: IMPORT_TIMEOUT,
  });
}

export function updateEnrollmentsStatus(members, courseID) {
  return v3.post(`${baseURL}/${courseID}/enrollment`, members, {
    timeout: UPDATE_ENROLLMENTS_TIMEOUT,
  });
}

export function updateCourse(courseID, params) {
  return v3.put(`${baseURL}/${courseID}`, params);
}

export function fetchWorkshops(courseID) {
  return v3.get(`${baseURL}/${courseID}/workshops`);
}

export function createCourse(params) {
  return v3.post(`${baseURL}`, params);
}

export function deleteCourse(id) {
  return v3.delete(`${baseURL}/${id}`);
}

export function resendCompletionEmail(params) {
  return v3.post(`${baseURL}/resend-completion-email`, params);
}
